import { render, staticRenderFns } from "./bfhs-button.vue?vue&type=template&id=f0fc6880&scoped=true&"
import script from "./bfhs-button.vue?vue&type=script&lang=js&"
export * from "./bfhs-button.vue?vue&type=script&lang=js&"
import style0 from "./bfhs-button.vue?vue&type=style&index=0&id=f0fc6880&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fc6880",
  null
  
)

export default component.exports